import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IMessageConfig } from '../models/dialogs.interfaces';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {

  title: string;
  message: string;
  closeButton: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: IMessageConfig) {
    this.title = data.title;
    this.message = data.message;
    this.closeButton = data.closeButton || 'common.close';
  }

}
